<template>
  <div class="home">
    <el-card class="box-card">
      <h1>注册TeamerClub</h1>
      <el-form ref="up-form" :rules="formRules" :model="form" label-width="140px">
        <el-form-item prop="name" label="名字">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="school" label="所在学校">
          <el-input v-model="form.school"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item prop="passwordAgain" label="再次输入一遍密码">
          <el-input type="password" v-model="form.passwordAgain"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="phoneNum" label="手机号">
          <el-input v-model="form.phoneNum"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="down-form" :model="form" :rules="formRules" label-width="80px">
        <el-form-item prop="vartifyCode" label="验证码"> -->
          <!-- <el-input v-model="form.vartifyCode"></el-input> -->
          <!-- <el-button @click="getVartifyCode" style="margin-top:10px" type="primary">获得验证码</el-button>
        </el-form-item> -->
        <el-form-item>
            
          <el-button @click="getVartifyCode" :loading="registerLoading">{{ regBtnText }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// @ is an alias to /src
import AV from '../api/config'
export default {
  name: "register",
  components: {},
  created() {
    this.$store.dispatch("showORhideBar", false);
  },
  data() {
    var checkPassword = (rule, value, callback) => {
        var that = this
      if (!value) {
        return callback(new Error("密码不能为空"));
      }
      setTimeout(() => {
        if (value != that.form.password) {
            callback(new Error("两次输入的密码不一致。"))
        }
      }, 100);
    };
    return {
      regBtnText: '注册',
      registerLoading: false,
      form: {
        name: "",
        school: "",
        email: "",
        password: '',
        passwordAgain: ''
        // phoneNum: "",
        // vartifyCode: ""
      },
      formRules: {
        name: [
          { required: true, message: "请告诉我你的名字", trigger: "blur" },
          {min:3,max:12,message:'名字长度不符合要求'}
        ],
        school: [
          {
            required: true,
            message: "学校要用于区分不同学校的同名用户欧！",
            trigger: "blur"
          },
          {max:30,message:'学校名字有这么长？'}
        ],
        email: [
          {
            type: 'email',
            required: true,
            message: "一个可以用的邮箱是找回丢失账号的好办法。",
            trigger: "blur"
          }],
        password: [
            {
                message: '密码长度必须在8~15个字符之间',
                required: true,
                min: 8,
                max: 15
            }
        ],
        passwordAgain: [
            {
                required: true,
                validator: checkPassword,
                trigger: "blur"
            }
        ]
        // ],
        // phoneNum: [{ required: true, validator: checkPhone, trigger: "blur" }]
      }
    };
  },
  methods: {
    getVartifyCode() {
      this.regBtnText = "正在处理..."
        this.registerLoading = true
        var usr = new AV.User()
        usr.setUsername(this.form.name),
        usr.setPassword(this.form.password)
        usr.setEmail(this.form.email)
        usr.set('School', this.form.school);
        usr.signUp().then((usr)=>{
          this.$notify({title:'欢迎你！',message:'感谢你使用TeamerClub,希望你会喜欢！',type:'success'})
        },(err)=>{
          alert('s')
          var cod = err.code
          if (cod==202)
          {
            this.$notify({title:'Ohno.',message:'用户名已经存在了噢',type:'error'})
          }
          else if (cod==203)
          {
            this.$notify({title:'Ohno.',message:'邮箱已经存在了噢',type:'error'})
          }
          else
          {
            this.$notify({title:'Ohno.',message:'出现了一些问题。',type:'warning'})
          }
          this.registerLoading = false
          this.regBtnText = "注册"
        })
        
    }
  }
};
</script>



<style>
.el-card__body {
    margin-left: 60px;
    margin-right: 60px;
}

.el-tag {
  margin-left: 10px;
}
.home {
  margin-top: 40px;
  margin-left: 20px;
}
</style>